/*********************************************************************************************
 * Gère les boutons de soumission personnalisés.
 */
function handleSubmitButtons() {
    document.querySelectorAll('[data-trigger-submit="true"]').forEach(function (button) {
        button.addEventListener('click', function (event) {
            event.preventDefault(); // Empêche tout comportement par défaut
            const submitInput = document.querySelector('.mm-contact-submit-input');
            if (submitInput) {
                submitInput.click();
            }
        });
    });
}

/**
 * Affiche un message de succès si le formulaire a été soumis.
 */
function handleSuccessMessage() {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    
    if (params.get('contact_posted') === 'true') {
        window.log('info', '📬 [CONTACT-FORM]', 'contact_posted=true détecté');
        const successMessage = document.querySelector('.mm-form-success-message');
        const contactForm = document.querySelector('.mm-contact-form');
        if (successMessage) {
            successMessage.classList.remove('mm-none');
            successMessage.classList.add('mm-block');
            contactForm.classList.add('mm-none');
        }
    }
}

/*********************************************************************************************
 * DOM Loaded Listener
 *
 */
document.addEventListener("DOMContentLoaded", () => {
    handleSubmitButtons();
    handleSuccessMessage();
});

/*********************************************************************************************
 * Resized Listener
 *
 */
window.addEventListener('resize', () => {
});
